module.exports = __webpack_public_path__ + "img/37.2e73064c.jpg";